/*
  Two behaviours that have nowhere else to live, and nothing else.

  This file used to be 312 lines and **none of them ran**. It opened by patching
  `Flickity.prototype`, and there is no global `Flickity` in this theme — Expanse 9's sliders
  import `vendor.flickity` as a module — so the first statement threw a ReferenceError and the rest
  of the file never executed. Measured: `--headerHeight`, which it sets on `load`, was empty on
  every page.

  Removing the throw would not have helped much. What it was guarding, checked against the rendered
  DOM:

    #added-to-cart-notification   markup does not exist — ~90 lines, and it called
                                  `window.app.currencyExchange` and `theme.QtySelector`, neither of
                                  which exists either
    .quick-add-btn                no such markup; `checkProductsInCart` had nothing to check
    .cart__item-remove            handler called `theme.cart`, undefined
    .lang-switcher__modal         replaced by `pz.localization-selector`
    [data-href]                   no element in the theme carries it
    collection:section:loaded     built a Flickity slider from the global that is not there
    --headerHeight                computed, set, and read by no stylesheet
    the sales-popup move          referenced an undeclared `productMetaBox`

  All of it went. What is below is what survives contact with the rendered page.
*/

/*
  The Algolia app's mobile search opens a detached overlay and does not focus its own input, so the
  keyboard does not come up. Delegated, because the button is the app's and is re-rendered.
*/
document.addEventListener('click', function (event) {
  const target = event.target
  if (!target || !target.classList || !target.classList.contains('aa-DetachedSearchButton')) return

  /* The overlay is mounted a frame or two after the click; 300ms is the old theme's number and it
     has been reliable. */
  setTimeout(function () {
    const input = document.querySelector('.aa-Input')
    if (input) input.focus()
  }, 300)
})

/*
  The AIOD discounts app marks the checkout button while its own request is in flight and does not
  clear the mark if the page is restored from the back/forward cache — leaving checkout inert. This
  hands it back on the way out.
*/
window.addEventListener('pagehide', function () {
  document.querySelectorAll('button[name="checkout"].aiod_checkout_clicked').forEach(function (button) {
    button.classList.remove('aiod_checkout_clicked')
    button.classList.add('aiod_cart_loaded')
  })
})

// fix account AR link in header
customElements.whenDefined('shopify-account').then(() => {
  const interval = setInterval(() => {
    const account = document.querySelector('shopify-account');
    const link = account?.shadowRoot?.querySelector('a[href="/account"]');

    if (link && window.Shopify.routes.root.includes('ar')) {
      link.href = '/ar/account';
      clearInterval(interval);
    }
  }, 100);
});